import { PROJECT_DIRECTORY_PAGE, PROJECT_DIRECTORY_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const projectDirectoryRoute = createGlobalRoute({
  exact: false,
  name: PROJECT_DIRECTORY_PAGE,
  path: PROJECT_DIRECTORY_PATH,
  capabilities: ['projects_app:access'],
  subproduct: 'townsquare-projects',
  enableRestrictedFallback: true,
});

export const projectNoWorkspaceDirectoryRoute = createGlobalRoute({
  exact: false,
  name: PROJECT_DIRECTORY_PAGE,
  path: PROJECT_DIRECTORY_PATH,
  resources: [],
  subproduct: 'townsquare-projects',
});
